import { getByClass, getFirst, tagScript } from "@src/utils/dom";
import { siteActivityGame } from "@shared/constants";
import { useScrolled } from "../components/front/PageScrolled";
import { pageArticleIdn } from "../store/elements";
import useVisibility from "@src/hooks/useVisibility";
import { ComponentType, lazy, LazyExoticComponent, Suspense } from "react";
import {
  GameTypeBarleyBreak,
  GameTypeBoulderDash,
  GameTypeColoring,
  GameTypeCrossing,
  GameTypeDropDown,
  GameTypeFindDiff,
  GameTypeFindPair,
  GameTypeFlyUp,
  GameTypeIslands,
  GameTypeMahjong,
  GameTypeMandala,
  GameTypeMatchThree,
  GameTypePokerMachine,
  GameTypePuzzle,
  GameTypeRepeat,
  GameTypeStratego,
  GameTypeTetris,
  GameTypeThreeBoom,
  GameTypeXonix,
  GameTypeZuma
} from "@shared/funny/const";

const nodeGame = getByClass(siteActivityGame)[0];

export default function GameLoader() {
  if (!useScrolled() || !nodeGame || !pageArticleIdn) return null;
  return <GameVisibility target={nodeGame} />;
}

function GameVisibility({ target }: { target: HTMLElement }) {
  if (!useVisibility(target, true)) return null;
  let GameLazy: LazyExoticComponent<ComponentType<any>> | undefined;
  switch (target.dataset.name) {
    case GameTypeMandala:
      GameLazy = lazy(() => import("./mandala/components/app"));
      break;
    case GameTypeStratego:
      GameLazy = lazy(() => import("./stratego/components/app"));
      break;
    default:
      return <Games target={target} />;
  }
  if (!GameLazy) return null;
  return (
    <Suspense fallback={null}>
      <GameLazy target={target} />
    </Suspense>
  );
}

function Games({ target }: { target: HTMLElement }) {
  let GameLazy: LazyExoticComponent<ComponentType<{ target: HTMLElement; data: any }>> | undefined;
  const gameType = target.dataset.name as string;
  switch (gameType) {
    case GameTypeRepeat:
      GameLazy = lazy(() => import("./repeat/index"));
      break;
    case GameTypeBarleyBreak:
      GameLazy = lazy(() => import("./barley-break/index"));
      break;
    case GameTypeFindPair:
      GameLazy = lazy(() => import("./find-pair/index"));
      break;
    case GameTypeMahjong:
      GameLazy = lazy(() => import("./mahjong/index"));
      break;
    case GameTypeMatchThree:
      GameLazy = lazy(() => import("./match-three/index"));
      break;
    case GameTypePuzzle:
      GameLazy = lazy(() => import("./puzzle/index"));
      break;
    case GameTypeThreeBoom:
      GameLazy = lazy(() => import("./three-boom/index"));
      break;
    case GameTypeTetris:
      GameLazy = lazy(() => import("./tetris/index"));
      break;
    case GameTypeXonix:
      GameLazy = lazy(() => import("./xonix/index"));
      break;
    case GameTypeCrossing:
      GameLazy = lazy(() => import("./crossing/index"));
      break;
    case GameTypeColoring:
      GameLazy = lazy(() => import("./coloring/index"));
      break;
    case GameTypeFindDiff:
      GameLazy = lazy(() => import("./find-diff/index"));
      break;
    case GameTypePokerMachine:
      GameLazy = lazy(() => import("./poker-machine/index"));
      break;
    case GameTypeDropDown:
      GameLazy = lazy(() => import("./drop-down/index"));
      break;
    case GameTypeFlyUp:
      GameLazy = lazy(() => import("./fly-up/index"));
      break;
    case GameTypeZuma:
      GameLazy = lazy(() => import("./zuma/index"));
      break;
    case GameTypeIslands:
      GameLazy = lazy(() => import("./islands/index"));
      break;
    case GameTypeBoulderDash:
      GameLazy = lazy(() => import("./boulder-dash/index"));
      break;
  }
  if (!GameLazy) return null;
  const script = getFirst(tagScript, target);
  const data = JSON.parse(script.innerText);
  target.innerHTML = "";
  return (
    <Suspense fallback={null}>
      <GameLazy target={target} data={data} />
    </Suspense>
  );
}
